document.addEventListener('DOMContentLoaded', () => {
  if (
    (document.getElementById('sidebar-cart') &&
      document.getElementById('sidebar-cart').getAttribute('aria-hidden') == 'false') ||
    document.getElementById('sidebar-cart') == null
  ) {
    var categoryElement = document.querySelectorAll('.wrapper-slider-inner .swiper-slide');
    if (categoryElement && categoryElement.length > 0) {
      categoryElement.forEach((items) => {
        items.addEventListener('click', (e) => {
          let temp = {};
          let pageType = '';

          if (simply.template == 'collection') {
            pageType = 'PLP';
          } else if (simply.template == 'product') {
            pageType = 'PDP';
          } else if (simply.template == 'cart') {
            pageType = 'cart';
          } else {
            pageType = simply.template;
          }
          temp = {
            event: 'category_widget',
            event_category: items.querySelector('.title-text').innerText,
            event_action: location.pathname,
            event_label: pageType,
          };
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            ...temp,
          });
          //location.href = items.querySelector("a").getAttribute("data-href")
        });
      });
    }
  }

  var swiperSlider = new Swiper('.category-slider-inner', {
    slidesPerView: 6,
    spaceBetween: 1,
    autoHeight: true, //enable auto height
    //mousewheel: true,
    //keyboard: true,
    navigation: {
      nextEl: '.swiper-button-next-arrow',
      prevEl: '.swiper-button-prev-arrow',
    },
    breakpoints: {
      320: {
        slidesPerView: 3.2, // Show 3 images in cart drawer, 3.2 on regular pages
        spaceBetween: 1,
      },
      375: {
        slidesPerView: 3.2, // Show 3 images in cart drawer, 3.2 on regular pages
        spaceBetween: 1,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 1,
      },
      1100: {
        slidesPerView: 6,
        spaceBetween: 1,
      },
    },
  });
});
